/* nr-kombi.js — kombinationstemat 2026-09-26
   ------------------------------------------------------------------
   Kopplar det gamla temats startsida och sidhuvud (nr-*-sektionerna) till
   nya temats varukorg (Dawn: cart-drawer, pubsub). Laddas med defer från
   layout/theme.liquid efter pubsub.js och cart-drawer.js.

   window.nrKombiLaggTill(variantId, antal) lägger i varan med /cart/add.js
   och ber om lådans sektioner i samma svar, som temats egen köpknapp och
   "Fyll på till fri frakt" i assets/ha.js. Lådan ritas om och öppnas, och
   cartUpdate publiceras så att sidhuvudets räknare läser om antalet.
   Finns ingen låda går vi till /cart.

   Produktkortens köpknapp (snippets/nr-produktkort, .nrk__form) och
   snabbväljaren (assets/nr-snabbval.js) använder funktionen.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function laggTill(id, antal) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: antal || 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Det gick inte att lägga i varan.');
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          /* slutfix QA 1: som Dawns product-form.js – annars ligger is-empty kvar när
             korgen var tom och Dawn döljer raderna (.is-empty .cart__contents). */
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nr-kombi', cartData: res });
          }
        } else {
          window.location.href = '/cart';
        }
        return res;
      });
  }
  window.nrKombiLaggTill = laggTill;

  /* ---------------------------------------------------------------------
     Sökförslag (optimering 2026-09-26), flyttat från gamla temats
     assets/nr-mobil.js avsnitt 2 och gjort för flera formulär: sidhuvudets
     sökfält och heroens "Vad har du för besvär?".
     /search/suggest.json är enda vägen till kategorierna, söksidan
     returnerar inga kollektioner. Allt byggs med createElement och
     textContent, aldrig innerHTML: sökträffar är butiksdata. Stilen ligger i
     assets/nr-kombi.css avsnitt 11.
     --------------------------------------------------------------------- */
  function sokforslag(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || !window.fetch || form.dataset.nrSug) return;
    form.dataset.nrSug = '1';

    var box = document.createElement('div');
    box.className = 'nr-sug';
    box.setAttribute('role', 'listbox');
    form.appendChild(box);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-expanded', 'false');

    var timer = null, controller = null, rows = [], active = -1, lastQuery = '';

    function close() { box.classList.remove('is-on'); input.setAttribute('aria-expanded', 'false'); active = -1; }
    function open() { box.classList.add('is-on'); input.setAttribute('aria-expanded', 'true'); }
    function money(v) { return String(v).replace('.', ',') + ' kr'; }
    function heading(label) { var h = document.createElement('div'); h.className = 'nr-sug__group'; h.textContent = label; box.appendChild(h); }
    function row(url) { var a = document.createElement('a'); a.className = 'nr-sug__row'; a.href = url; box.appendChild(a); rows.push(a); return a; }
    function textBlock(title, meta) {
      var wrap = document.createElement('span'); wrap.className = 'nr-sug__txt';
      var name = document.createElement('span'); name.className = 'nr-sug__name'; name.textContent = title; wrap.appendChild(name);
      if (meta) { var m = document.createElement('span'); m.className = 'nr-sug__meta'; m.textContent = meta; wrap.appendChild(m); }
      return wrap;
    }

    function render(data, query) {
      box.textContent = ''; rows = []; active = -1;
      var res = (data.resources && data.resources.results) || {};
      var products = res.products || [], collections = res.collections || [], pages = res.pages || [];
      if (products.length) {
        heading('Produkter');
        products.forEach(function (p) {
          var a = row(p.url);
          var img = document.createElement('span'); img.className = 'nr-sug__img';
          if (p.featured_image && p.featured_image.url) { var i = document.createElement('img'); var u = p.featured_image.url; i.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96'; i.alt = ''; i.width = 40; i.height = 40; i.loading = 'lazy'; img.appendChild(i); }
          a.appendChild(img);
          a.appendChild(textBlock(p.title, [p.vendor, money(p.price)].filter(Boolean).join(' · ')));
        });
      }
      if (collections.length) { heading('Kategorier'); collections.forEach(function (c) { row(c.url).appendChild(textBlock(c.title, 'Kategori')); }); }
      if (pages.length) { heading('Guider'); pages.forEach(function (p) { row(p.url).appendChild(textBlock(p.title, 'Skadeguiden')); }); }
      if (!rows.length) {
        var empty = document.createElement('div'); empty.className = 'nr-sug__empty'; empty.textContent = 'Inga förslag för "' + query + '".';
        box.appendChild(empty); open(); return;
      }
      var all = document.createElement('button'); all.type = 'submit'; all.className = 'nr-sug__all';
      all.textContent = 'Visa alla träffar för "' + query + '"';
      box.appendChild(all); rows.push(all);
      open();
    }

    function highlight(next) {
      if (!rows.length) return;
      if (active > -1) rows[active].classList.remove('is-active');
      active = (next + rows.length) % rows.length;
      rows[active].classList.add('is-active');
      rows[active].scrollIntoView({ block: 'nearest' });
    }

    function hamta(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection,page&resources[limit]=4&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (input.value.trim() === query) render(data, query); })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (timer) clearTimeout(timer);
      if (q.length < 2) { close(); lastQuery = ''; return; }
      if (q === lastQuery) return;
      lastQuery = q;
      timer = setTimeout(function () { hamta(q); }, 200);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (!box.classList.contains('is-on')) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Enter' && active > -1 && rows[active].tagName === 'A') { e.preventDefault(); rows[active].click(); }
    });
    input.addEventListener('focus', function () { if (rows.length && input.value.trim().length > 1) open(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  function initSok() {
    document.querySelectorAll('[data-nr-header] form[role="search"], [class^="nrhb-"][class$="__sok"]').forEach(sokforslag);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSok);
  else initSok();
  document.addEventListener('shopify:section:load', initSok);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.nrk__form');
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    var btn = form.querySelector('button[type="submit"]');
    if (!input) return;
    e.preventDefault();
    if (btn && btn.disabled) return;
    var etikett = btn && btn.querySelector('span');
    var text = etikett ? etikett.textContent : '';
    if (btn) btn.disabled = true;
    if (etikett) etikett.textContent = 'Lägger till …';
    laggTill(input.value, 1)
      .catch(function () { form.submit(); })
      .then(function () {
        if (btn) btn.disabled = false;
        if (etikett) etikett.textContent = text;
      });
  });
})();
